import React from 'react';
import { ChevronDown } from 'lucide-react';

export function Select({ children, placeholder, onChange, value }) {
  return (
    <div className="relative">
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg appearance-none pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {children}
      </select>
      <ChevronDown className="w-4 h-4 text-gray-400 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none" />
    </div>
  );
}

Select.Option = function Option({ children, value }) {
  return (
    <option value={value}>
      {children}
    </option>
  );
}; 